import Vue from 'vue'
import Router from 'vue-router'
import Item from '@/components/Item'
import Index from '@/components/Index'
import Order from '@/components/Order'
import Privacy from '@/components/Privacy'
import Terms from '@/components/Terms'
import Login from '@/components/Login'
import Oauth from '@/components/Oauth'
import Logout from '@/components/Logout'
import Category from '@/components/Category'
import Member from '@/components/Member'
import Address from '@/components/Address'
import Coupon from '@/components/Coupon'
import Cart from '@/components/Cart'
import AddAddress from '@/components/AddressInfo'
import Checkout from '@/components/Checkout'
import Success from '@/components/Success'
import List from '@/components/List'
import Search from '@/components/Search'
import Result from '@/components/Result'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '首頁',
        showTabBar: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登入',
        showTabBar: false
      }
    },
    {
      path: '/oauth',
      name: 'Oauth',
      component: Oauth,
      meta: {
        title: '登入',
        showTabBar: false
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      meta: {
        title: '登出',
        showTabBar: false
      }
    },
    {
      path: '/order',
      name: 'Order',
      component: Order,
      meta: {
        title: '訂單記錄',
        showTabBar: true
      }
    },
    {
      path: '/category',
      name: 'Category',
      component: Category,
      meta: {
        title: '商品分類',
        showTabBar: true
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        title: '搜索商品',
        showTabBar: false
      }
    },
    {
      path: '/result',
      name: 'Result',
      component: Result,
      meta: {
        title: '搜尋結果',
        showTabBar: false
      }
    },
    {
      path: '/member',
      name: 'Member',
      component: Member,
      meta: {
        title: '會員中心',
        showTabBar: true
      }
    },
    {
      path: '/address',
      name: 'Address',
      component: Address,
      meta: {
        title: '收貨資料',
        showTabBar: true
      }
    },
    {
      path: '/address/add',
      name: 'AddAddress',
      component: AddAddress,
      meta: {
        title: '添加地址',
        showTabBar: false
      }
    },
    {
      path: '/address/edit/:id',
      name: 'AddAddress',
      component: AddAddress,
      meta: {
        title: '修改地址',
        showTabBar: false
      }
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
      meta: {
        title: '結賬',
        showTabBar: false
      }
    },
    {
      path: '/list',
      name: 'List',
      component: List,
      meta: {
        title: '商品列表',
        showTabBar: false
      }
    },
    {
      path: '/coupon',
      name: 'Coupon',
      component: Coupon,
      meta: {
        title: '優惠折扣',
        showTabBar: true
      }
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        title: '購物車',
        showTabBar: true
      }
    },
    {
      path: '/success',
      name: 'Success',
      component: Success,
      meta: {
        title: '訂單完成',
        showTabBar: true
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      meta: {
        title: '隱私權政策',
        showTabBar: false
      }
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms,
      meta: {
        title: '服務政策',
        showTabBar: false
      }
    },
    {
      path: '/:code',
      name: 'Item',
      component: Item
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js